/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductDropdown } from '../../models/product-dropdown';

export interface ApiProductcategoryDropDownGet$Params {
  'api-version'?: string;
}

export function apiProductcategoryDropDownGet(http: HttpClient, rootUrl: string, params?: ApiProductcategoryDropDownGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductDropdown>>> {
  const rb = new RequestBuilder(rootUrl, apiProductcategoryDropDownGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductDropdown>>;
    })
  );
}

apiProductcategoryDropDownGet.PATH = '/api/productcategory/drop-down';
